// extracted by mini-css-extract-plugin
module.exports = {"confirm_content":"confirmModal_confirm_content__pbVJg","main_cont":"confirmModal_main_cont__9ff8X","oper_wrap":"confirmModal_oper_wrap__A15PU"};